import ExploreAuth from '../utils/ExploreAuth';

require("es6-promise").polyfill();
import fetch from "isomorphic-fetch";
import { SubmissionError } from "redux-form";
import { authLoginUserSuccess, authLogoutAndRedirect, disqusSetSSO, } from './auth';
import { checkHttpStatus, parseJSON } from "../utils";
import { fetchMemberProfile, memberProfileSuccess } from './memberProfile';
import { setUserPreferences } from "./uiPreferences";
import {
  CURRENT_USER_REQUEST,
  CURRENT_USER_SUCCESS,
  CURRENT_USER_FAILURE,
  CURRENT_USER_SAVE_REQUEST,
  CURRENT_USER_SAVE_SUCCESS,
  CURRENT_USER_SAVE_FAILURE,
  CURRENT_USER_UPDATE_AVATAR, CURRENT_USER_RESET, CURRENT_USER_NEW_NOTIFICATIONS, CURRENT_USER_CLEAR_NOTIFICATIONS
} from '../constants';

export function currentUserSuccess(user) {
  return {
    type: CURRENT_USER_SUCCESS,
    payload: {
      user
    }
  };
}

export function currentUserFailure() {
  return {
    type: CURRENT_USER_FAILURE
  };
}

export function currentUserRequest() {
  return {
    type: CURRENT_USER_REQUEST
  };
}

export function saveUserProfileRequest() {
  return {
    type: CURRENT_USER_SAVE_REQUEST
  };
}

export function saveUserProfileSuccess(data) {
  return {
    type: CURRENT_USER_SAVE_SUCCESS,
    payload: {
      data
    }
  };
}

export function saveUserProfileFailure() {
  return {
    type: CURRENT_USER_SAVE_FAILURE
  };
}

export function currentUserReset() {
  return {
    type: CURRENT_USER_RESET,
  };
}

export function setNewNotifications(unreadNotifications) {
  return {
    type: CURRENT_USER_NEW_NOTIFICATIONS,
    payload: {
      unreadNotifications,
    },
  };
}

export function clearNotifications() {
  return {
    type: CURRENT_USER_CLEAR_NOTIFICATIONS,
  };
}

export function fetchCurrentUser() {
  return dispatch => {
    dispatch(currentUserRequest());
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          return dispatch(authLogoutAndRedirect());
        }
        return fetch(`${SERVER_URL}/auth/get_authenticated_user_info`, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'x-www-form-urlencoded',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then(response => {
            dispatch(currentUserSuccess(response.data));
            dispatch(setUserPreferences(response.data.preferences));
          })
          .catch(error => {
            dispatch(currentUserFailure());
          });
      });
  };
}

export function saveUserProfile(values, removeModal, successCallback) {
  return dispatch => {
    let requestValues = values;
    if (values.fav_order) {
      requestValues.fav_order = JSON.stringify(values.fav_order);
    }
    dispatch(saveUserProfileRequest());
    let body = JSON.stringify(requestValues);

    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          return dispatch(authLogoutAndRedirect());
        }
        return fetch(`${SERVER_URL}/accounts/edit_profile`, {
          method: 'post',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
          body,
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then(response => {
            dispatch(fetchMemberProfile(response.data.username));
            dispatch(authLoginUserSuccess(response.user));
            dispatch(saveUserProfileSuccess(response.data));
            dispatch(setUserPreferences(response.user.preferences));
            dispatch(disqusSetSSO(response.user.disqus_sso));
            if (removeModal) {
              removeModal();
              window.dispatchEvent(new CustomEvent("checkImageLazyload"));
            }
            if (successCallback) {
              successCallback(response);
            }
          })
          .catch(error => {
            dispatch(saveUserProfileFailure(error.message));
            throw new SubmissionError({ _error: `Error submitting form: ${error.message}` });
          });
      });
  };
}

export function saveUserAvatar(avatar_uri) {
  return dispatch => {
    const body = JSON.stringify({ avatar_uri });

    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          return dispatch(authLogoutAndRedirect());
        }
        return fetch(`${SERVER_URL}/accounts/save_avatar`, {
          method: "post",
          credentials: "same-origin",
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
          body,
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then(response => {
            dispatch(memberProfileSuccess(response.data));
            dispatch(authLoginUserSuccess(response.data));
            dispatch(saveUserProfileSuccess(response.data));
            dispatch(setUserPreferences(response.user.preferences));
          })
          .catch(error => {
            throw new SubmissionError({ _error: `Error submitting form: ${error.message}`});
          });
      });
  };
};

export function updateAvatarUri(avatarUri) {
  return {
    type: CURRENT_USER_UPDATE_AVATAR,
    payload: {
      avatarUri,
    },
  };
}
